import { Link } from 'react-router-dom';
import React from 'react';
import { motion } from 'framer-motion';

const PhilosophySection = () => {
	const actionBlocks = [
		{
			id: 1,
			title: 'FIGHT FOR JUSTICE',
			bgColor: 'bg-gray-800',
			textColor: 'text-white',
			link: '/practice-areas',
		},
		{
			id: 2,
			title: 'BEST CASE STRATEGY',
			bgColor: 'bg-gray-600',
			textColor: 'text-white',
			link: '/attorneys',
		},
		{
			id: 3,
			title: 'REVIEW DOCUMENTS',
			bgColor: 'bg-[#800020]',
			textColor: 'text-white',
			link: '/services',
		},
		{
			id: 4,
			title: 'WE ACHIEVE RESULTS',
			bgColor: 'bg-[#DB954E]',
			textColor: 'text-white',
			link: '/contact',
		},
	];

	return (
		<section className='relative overflow-hidden'>
			{/* Header Section with Classical Architecture Background */}
			<div className='relative min-h-[300px] flex items-center justify-center'>
				{/* Background Image */}
				<div className='absolute inset-0'>
					<div className='w-full h-full bg-gradient-to-br from-gray-200 via-gray-100 to-gray-200 opacity-90'></div>
					{/* Classical Architecture Pattern */}
					<div className='absolute inset-0 opacity-20'>
						{/* Columns */}
						<div className='absolute bottom-0 left-1/4 w-8 h-32 bg-gray-400'></div>
						<div className='absolute bottom-0 left-1/2 w-8 h-32 bg-gray-400'></div>
						<div className='absolute bottom-0 right-1/4 w-8 h-32 bg-gray-400'></div>
						{/* Steps */}
						<div className='absolute bottom-0 left-0 w-full h-4 bg-gray-300'></div>
						<div className='absolute bottom-4 left-0 w-full h-4 bg-gray-300'></div>
						<div className='absolute bottom-8 left-0 w-full h-4 bg-gray-300'></div>
						{/* Base */}
						<div className='absolute bottom-12 left-0 w-full h-8 bg-gray-400'></div>
					</div>
				</div>

				{/* Title */}
				<motion.div
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
					viewport={{ once: true }}
					className='relative z-10 text-center'
				>
					<h2 className='font-source font-bold text-4xl md:text-5xl lg:text-6xl text-gray-800 uppercase tracking-wide'>
						Our Philosophy
					</h2>
				</motion.div>
			</div>

			{/* Philosophy Text Section */}
			<div className='bg-white py-16'>
				<div className='max-w-4xl mx-auto px-4 sm:px-6 lg:px-8'>
					<motion.div
						initial={{ opacity: 0, y: 30 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.8, delay: 0.2 }}
						viewport={{ once: true }}
						className='space-y-6'
					>
						<p className='font-source text-lg text-gray-800 leading-relaxed'>
							Our philosophy is premised on cutting edge professional services, personal excellence,
							integrity, strength and innovation. We explore modern technology, prioritize hard
							work, and hold all our professionals to high standard. Our team is endowed with the
							capacity to take on the challenges of our demanding and evolving legal practice.
						</p>

						<p className='font-source text-lg text-gray-800 leading-relaxed'>
							We appreciate the rich and diverse perspectives of our team of professionals. Our
							reputation of excellence, innovation, integrity and diverse areas of practice ensures
							the continued success of our firm.
						</p>
					</motion.div>
				</div>
			</div>

			{/* Action Blocks Section */}
			<div className='bg-gray-50 py-16'>
				<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
					<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
						{actionBlocks.map((block, index) => (
							<motion.div
								key={block.id}
								initial={{ opacity: 0, y: 30 }}
								whileInView={{ opacity: 1, y: 0 }}
								transition={{ duration: 0.6, delay: index * 0.1 }}
								viewport={{ once: true }}
								whileHover={{ scale: 1.05 }}
								whileTap={{ scale: 0.95 }}
							>
								<Link to={block.link}>
									<div
										className={`${block.bgColor} ${block.textColor} rounded-lg p-8 h-32 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group`}
									>
										<h3 className='font-source font-bold text-lg uppercase tracking-wide text-center group-hover:scale-110 transition-transform duration-300'>
											{block.title}
										</h3>
									</div>
								</Link>
							</motion.div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};

export default PhilosophySection;
